var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.fixDate
    ? _c("div", { staticClass: "date" }, [
        _vm._v("\n  " + _vm._s(_vm.fixDate) + " "),
        _c("span", { staticClass: "date__author" }, [
          _vm._v(_vm._s(_vm.author)),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }